import { HOSTS } from '../constants/environment.constants'
import UrlUtil from './url.utils'

export const getHostName = () => {
  const url = UrlUtil.getLocationHref()

  for (let key in HOSTS) {
    if (url.includes(HOSTS[key])) {
      return key.toLocaleLowerCase()
    }
  }
}
